import './OfficialAccountCustomComponent.less';
import { Toast } from 'antd-mobile';

export default function OfficialAccountCustomComponent(props) {
  /**
   * 返回组件（TODO：如果非预览，应该要隐藏当前组件）
   */
  const imgStyle = {
    width: '100%',
  }
  const showToast = ()=> {
    Toast.info('仅为预览图效果，实际功能请在小程序端体验(该组件仅支持微信小程序)')
  }
  return (
    <div className="custom-component" onClick={showToast}>
      <img style={imgStyle} src="http://cdn.jisuapp.cn/zhichi_frontend/static/webapp/images/unDoFunctionImgs/official-account.png" alt="公众号关注组件（仅支持微信小程序)"/>
      {/* <p>公众号关注组件（仅支持微信小程序）</p> */}
    </div>
  );
}


// WEBPACK FOOTER //
// ./src/custom-component/official-account-component/OfficialAccountCustomComponent.jsx